import { useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import UserDetailsGeneralInformation from './GeneralInformation'
import UserDetailsGroups from './Groups'

import BackNavigation from '~/components/BackNavigation'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import Layout from '~/components/Layouts/Layout'
import MwMLoader from '~/components/MwMLoader'
import ViewTitle from '~/components/ViewTitle'
import { useMwmUsersDetailsQuery } from '~/queries/user-management'
import { capitalize } from '~/utils/string'

const UserDetails = (): ReactElement | null => {
  const { userId } = useParams<{ userId: string }>()

  const { data: user, isLoading } = useMwmUsersDetailsQuery(userId)

  if (isLoading) {
    return (
      <Layout>
        <MwMLoader category="item" />
      </Layout>
    )
  }

  if (!user) {
    return null
  }

  const { email, name, picture, profile, status, updated_at_ts, updated_by, user_id } = user

  const updatedBy = {
    date: updated_at_ts,
    name: updated_by.name,
    picture: updated_by.picture,
  }

  return (
    <Layout>
      <ViewTitle className="flex justify-space-between">
        <BackNavigation title="Users" to="/mwm-users/users" />
        <div className="flex align-center justify-center">User detail</div>
        <LastUpdatedByCard updatedBy={updatedBy} />
      </ViewTitle>
      <UserDetailsGeneralInformation
        email={email}
        id={user_id}
        job={profile?.job_title}
        name={capitalize(name)}
        picture={picture}
        status={status}
      />
      <UserDetailsGroups user={user} />
    </Layout>
  )
}

export default UserDetails
